import React from "react";
import { Box, Typography } from "@mui/material";

export default function FulfillmentPolicy(props) {
  return (
    <Box my={2} id="fulfillment-policy">
      <Typography variant="subtitle1">Fulfillment Policy</Typography>
      <Box>
        <Typography variant="caption" color="textSecondary">
          Orders must be picked up at the scheduled date and time. If we're not informed of a delay, the order will be held only until close of
          business that day. No refunds or credits will be issued for missed pickups. For deliveries, someone 18 or older must be present to receive
          the order. If no one is available, the order will be returned to the bakery. A redelivery can be arranged, but a new delivery fee will apply
          and may be equal to or higher than the original.
        </Typography>
      </Box>
    </Box>
  );
}
